var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('form',{staticClass:"form",on:{"submit":function($event){$event.preventDefault();return _vm.handlePolicy.apply(null, arguments)}}},[_c('AddPolicyFields'),_vm._m(0)],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-wrap form-submit"},[_c('div',[_c('button',{staticClass:"button",attrs:{"type":"submit"}},[_vm._v("\n            Add Policy\n          ")])])])
}]

export { render, staticRenderFns }